import { useRecoilValue, useSetRecoilState } from "recoil";
import { CommunityBoardListState_SubMenu, IsBottomLoading } from "../../recoil/states";

const TopBtns = () => {
    const setIsBottomLoading = useSetRecoilState(IsBottomLoading); // 바닥 로딩바 표시 처리를 위해 사용되는 state
    const communityBoardListState_SubMenu = useRecoilValue(CommunityBoardListState_SubMenu); // 게시물 상세 UI 랜더링 처리를 위해 사용되는 state

    /**
     * 상단 '전체 / 일간 / 주간 / 월간' 버튼 클릭 이벤트
     * 
     * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
     * @returns {void}
     */
    const handlerTopBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, sub_menu: string): void => {
        e.preventDefault();

        setIsBottomLoading(false); // 바닥 로딩바 숨김 처리

        let query_string = (sub_menu === "" ? "" : "&sub_menu=" + encodeURIComponent(sub_menu));
        if (query_string !== "") query_string = "?" + query_string.substring(1);

        const url: string = "/community_board_list" + query_string;
        (window as any).urlChange(url);
    }

    return (
      <div id="div_sub_menu_ui" className="bo_list" style={{textAlign: "center"}}>
          <nav className="bo_cate" id="nav_sub_menu" style={{display: "inline-block", width: "100%"}}>
              <ul className="bo_cate_ul">
                  <li><a href="#" className={communityBoardListState_SubMenu === "" ? "bo_cate_on" : ""} onClick={e => handlerTopBtn(e, '')}>전체</a></li>                  
                  <li><a href="#" className={communityBoardListState_SubMenu === "DAILY" ? "bo_cate_on" : ""} onClick={e => handlerTopBtn(e, 'DAILY')}>일간 <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></a></li>
                  <li><a href="#" className={communityBoardListState_SubMenu === "WEEKLY" ? "bo_cate_on" : ""} onClick={e => handlerTopBtn(e, 'WEEKLY')}>주간 <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></a></li>
                  <li><a href="#" className={communityBoardListState_SubMenu === "MONTHLY" ? "bo_cate_on" : ""} onClick={e => handlerTopBtn(e, 'MONTHLY')}>월간 <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></a></li>
              </ul>
          </nav>
      </div>
    )
}

export default TopBtns;
